import React from 'react';
import clsx from 'clsx';
import { formatPrice } from '@dashboard/services/formatting';

const TicketTypeMultiSelectList = ({
  ticketTypes = [],
  selectedTicketTypes = new Map(),
  onToggle,
  interactive = true,
}) => {
  if (!ticketTypes || ticketTypes.length === 0) {
    return <div className="flex flex-col gap-y-1">This event has no tickets yet.</div>;
  }

  return (
    <div className="flex flex-col gap-y-1">
      {ticketTypes.map(ticketType => {
        const isSelected = selectedTicketTypes.has(ticketType._id);

        return (
          <div
            className={clsx(
              'p-2 w-full text-left flex justify-between rounded border transition-colors border-gray-200',
              {
                'cursor-pointer hover:bg-gray-50': interactive,
                '!bg-gray-50 !border-chocolate-600': interactive && isSelected,
              },
            )}
            key={ticketType._id}
            onClick={interactive ? () => onToggle?.(ticketType) : undefined}
          >
            <div className="flex flex-row">
              <div className="flex flex-col mr-2">
                <div className="text-sm font-semibold break-words">{ticketType?.name}</div>
                <div className="text-sm text-gray-700">
                  {ticketType?.capacity !== null ? `${ticketType.capacity} tickets` : 'Unlimited'}
                  {' • '}
                  {ticketType?.quantitySold || '0'} sold
                </div>
              </div>
            </div>

            <div className="flex flex-col">
              <div className="text-base">
                {ticketType.pricing === 'paid' && ticketType.price > 0
                  ? formatPrice({
                      amount: ticketType?.price,
                      currency: 'usd',
                    })
                  : 'Free'}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TicketTypeMultiSelectList;
